import { render, staticRenderFns } from "./AssociationItems.vue?vue&type=template&id=8ee67802&scoped=true"
import script from "./AssociationItems.vue?vue&type=script&lang=js"
export * from "./AssociationItems.vue?vue&type=script&lang=js"
import style0 from "./AssociationItems.vue?vue&type=style&index=0&id=8ee67802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee67802",
  null
  
)

export default component.exports